<template>
   <AppLayout>
      <template #main>
         <section
            class="container bg-gray-200 mx-auto w-full h-full mt-16 mb-16"
         >
            <div v-if="noEvents" />

            <div v-else>
               <div
                  v-for="(dataItem, key) in grouped"
                  :key="`resource_${dataItem.id}`"
               >
                  <h2
                     class="text-center font-extrabold text-3xl uppercase"
                     :class="{ 'mt-16': key > 0 }"
                  >
                     {{ dataItem.year }}
                  </h2>
                  <Timeline :events="dataItem.events" />
               </div>
               <!--               <div-->
               <!--                  class="flex mt-16 justify-center"-->
               <!--                  role="status"-->
               <!--                  v-if="loadMoreYearData"-->
               <!--               >-->
               <!--                  <Button-->
               <!--                     size="small"-->
               <!--                     @click="loadPreviousYear"-->
               <!--                  >-->
               <!--                     Load more-->
               <!--                  </Button>-->
               <!--               </div>-->
               <div
                  class="flex mt-16 justify-center"
                  role="status"
                  v-if="isLoading"
               >
                  <svg
                     aria-hidden="true"
                     class="w-8 h-8 text-gray-200 animate-spin fill-primary-color-dark"
                     viewBox="0 0 100 101"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                     />
                     <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"
                     />
                  </svg>
                  <span class="sr-only">Loading...</span>
               </div>
            </div>
         </section>
         <div class="grid py-20 sm:py-20">
            <div class="col-start-1 row-start-1">
               <SponsorsSection />
            </div>
         </div>
      </template>
   </AppLayout>
</template>

<script setup>
   import AppLayout from '@/Layouts/AppLayout.vue';
   import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
   import { each, fromPairs, groupBy, isEmpty, orderBy, sortBy, toPairs } from 'lodash';
   import SponsorsSection from '@/Components/SponsorsSection.vue';
   import Timeline from '@/Components/Timeline/Timeline.vue';
   import Button from 'primevue/button';
   import dayjs from 'dayjs';


   const props = defineProps({
      eventsResource: Object,
   });

   const year = ref(parseInt(dayjs().format('YYYY')));
   const yearSubCounter = ref(0);


   const grouped = computed(() => {
      const groupedByYear = groupBy(props.eventsResource.data, 'year');
      const data = [];

      each(groupedByYear, function (collection, year) {
         data.push({
            year: year,
            events: collection,
         });
      });
      return orderBy(data, ['year'], 'desc');
   });

   const eventsResourceData = ref([
      {
         year: year.value,
         resourceData: props.eventsResource,
      },
   ]);
   const isLoading = ref(false);
   const loadMoreYearData = ref(true);
   const allPagesLoaded = ref(isEmpty(props.eventsResource.links.next));

   const noEvents = ref(isEmpty(props.eventsResource.data));

   const handleScroll = async (e) => {
      const pixelsFromBottom =
         document.documentElement.offsetHeight -
         document.documentElement.scrollTop -
         window.innerHeight;

      if (
         pixelsFromBottom < 400 &&
         isLoading.value === false &&
         allPagesLoaded.value === false
      ) {
         isLoading.value = true;
         const response = await axios.get(eventsResourceData.value.links.next);
         eventsResourceData.value = {
            links: response.data.links,
            data: [...eventsResourceData.value.data, ...response.data.data],
         };
         isLoading.value = false;
         allPagesLoaded.value = isEmpty(eventsResourceData.value.links.next);
      }
   };

   onMounted(() => window.addEventListener('scroll', handleScroll));

   onUnmounted(() => window.removeEventListener('scroll', handleScroll));

   const loadPreviousYear = async () => {
      yearSubCounter.value = yearSubCounter.value + 1;
      isLoading.value = true;
      const newYearData = {
         year: year.value - yearSubCounter.value,
      };
      const response = await axios.get(
         route('timeline.index', {
            year: year.value - yearSubCounter.value,
         }),
      );
      if (response.data.data.length <= 0) {
         loadMoreYearData.value = false;
         isLoading.value = false;
         return;
      }
      newYearData.resourceData = response.data;
      eventsResourceData.value.push(newYearData);

      isLoading.value = false;
      // allPagesLoaded.value = isEmpty(eventsResourceData.value.links.next);
   };
</script>

<style scoped></style>
